















































import Vue from "vue"
import { countryList } from "@/model/service/country/country-service"
import { CutOffTime } from "@/model/entity/cut-off-time/cut-off-time"
import store from "@/vuex/store"

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: Object as () => CutOffTime,
      default: null
    }
  },
  data() {
    return {
      cutOffTime: this.value ? Object.assign(new CutOffTime(), this.value) : new CutOffTime(),
      countryList: countryList,
      hoursOptions: (() => {
        const config = store.state.easyshipConfiguration && store.state.easyshipConfiguration.cutOffTime
        const min: number = (config && config.minimumCutOffHour) || 8
        const max: number = (config && config.maximumCutOffHour) || 16
        const steps = (max - min) * 2 + 1
        return Array.from({ length: steps }, (_, i) => {
          const totalMinutes = min * 60 + i * 30
          const h = Math.floor(totalMinutes / 60)
          const m = totalMinutes % 60
          const label = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
          return { value: label, label }
        })
      })(),
      rules: {
        postalCode: [
          {
            max: 9,
            message: `${this.$t("user_administration.max")} 9 ${this.$t("user_administration.chars")}`,
            trigger: ["change", "blur"]
          },
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ],
        time: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ]
      }
    }
  },
  computed: {
    isEditMode(): boolean {
      return !!(this.value && this.value.id)
    }
  },
  methods: {
    emitValidation() {
      const vm = this as any
      let isInfoFormValid
      vm.$refs.formInfo.validate((valid: boolean) => {
        isInfoFormValid = valid
      })
      this.$emit("validateForm", isInfoFormValid)
    }
  },
  watch: {
    cutOffTime: {
      deep: true,
      handler() {
        this.emitValidation()
        this.$emit("modelChanged", this.cutOffTime)
      }
    }
  },
  created() {
    this.cutOffTime.country = this.$store.state.authenticatedEmployee.office.country
  },
  mounted() {
    this.emitValidation()
  }
})
